<template>
  <div class="mensagem-retorno" :class="{ 'mensagem-retorno--larga': larga }">
    <div v-if="erro" class="erro-interpretado">
      <span class="erro-titulo">
        <fa-icon icon="exclamation-triangle" />
        {{ erro.titulo }}
        <small v-if="erro.codigo" class="erro-codigo">SQLSTATE {{ erro.codigo }}</small>
      </span>
      <span v-if="erro.descricao" class="erro-descricao">{{ erro.descricao }}</span>
      <button
        v-if="mostrarCopiar"
        type="button"
        class="btn-copiar"
        :title="copiado ? 'Copiado!' : 'Copiar mensagem'"
        @click="copiar"
      >
        <fa-icon :icon="copiado ? 'check' : 'copy'" />
        {{ copiado ? "Copiado" : "Copiar" }}
      </button>
    </div>

    <div class="mensagem-bruta-wrapper">
      <div v-if="mostrarCopiar && !erro" class="mensagem-toolbar">
        <button
          type="button"
          class="btn-copiar"
          :title="copiado ? 'Copiado!' : 'Copiar mensagem'"
          @click="copiar"
        >
          <fa-icon :icon="copiado ? 'check' : 'copy'" />
          {{ copiado ? "Copiado" : "Copiar" }}
        </button>
      </div>
      <div class="mensagem-bruta">{{ mensagem }}</div>
    </div>
  </div>
</template>

<script>
import { interpretarErroSincronizacao } from "@/helpers/sincronizacaoErros";

export default {
  name: "MensagemRetorno",
  props: {
    mensagem: {
      type: [String, Number],
      default: "",
    },
    // Solta o limite de largura (uso em tabelas chave/valor, ex.: Última sincronização)
    larga: {
      type: Boolean,
      default: false,
    },
    // Indica se a execução foi um sucesso. Quando explicitamente `false`/0, a
    // mensagem é tratada como erro e o botão "Copiar" aparece sempre (mesmo em
    // mensagens curtas ou em erros que o interpretador não reconhece).
    // `null` = desconhecido (cai no comportamento por tamanho/interpretação).
    sucesso: {
      type: [Boolean, Number],
      default: null,
    },
  },
  data() {
    return {
      copiado: false,
    };
  },
  computed: {
    erro() {
      return interpretarErroSincronizacao(String(this.mensagem || ""));
    },
    // Verdadeiro quando a mensagem representa uma falha: ou o pai sinalizou
    // sucesso === false, ou (sem sinalização) o interpretador reconheceu um erro.
    ehErro() {
      if (this.sucesso === false || this.sucesso === 0 || this.sucesso === "0") {
        return true;
      }
      if (this.sucesso === null || this.sucesso === undefined) {
        return !!this.erro;
      }
      return false;
    },
    mostrarCopiar() {
      // Em erros, sempre oferece copiar (independe do tamanho). Em mensagens de
      // sucesso, só quando longas, para não poluir os retornos curtos.
      if (this.ehErro) {
        return true;
      }
      return String(this.mensagem || "").length > 80;
    },
  },
  methods: {
    copiar() {
      const texto = String(this.mensagem || "");

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(texto)
          .then(() => this.marcarCopiado())
          .catch(() => this.copiarFallback(texto));
        return;
      }

      this.copiarFallback(texto);
    },
    copiarFallback(texto) {
      const el = document.createElement("textarea");
      el.value = texto;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand("copy");
        this.marcarCopiado();
      } catch (e) {
        // silencioso: navegador sem suporte a cópia
      }
      document.body.removeChild(el);
    },
    marcarCopiado() {
      this.copiado = true;
      setTimeout(() => {
        this.copiado = false;
      }, 1500);
    },
  },
};
</script>

<style scoped>
.mensagem-retorno {
  display: block;
  max-width: 460px;
}

.mensagem-retorno--larga {
  max-width: 100%;
}

.erro-interpretado {
  margin-bottom: 6px;
  padding: 6px 8px;
  border-left: 3px solid #e55353;
  background-color: #fdf1f1;
  border-radius: 3px;
}

.erro-titulo {
  display: block;
  font-weight: 600;
  color: #c0392b;
}

.erro-codigo {
  font-weight: 400;
  color: #9b9b9b;
}

.erro-descricao {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: #6c4040;
}

.mensagem-toolbar {
  text-align: right;
  margin-bottom: 4px;
}

.btn-copiar {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  font-size: 12px;
  line-height: 1.4;
  color: #5c6873;
  background-color: #fff;
  border: 1px solid #d8dbe0;
  border-radius: 5px;
  cursor: pointer;
}

.btn-copiar:hover {
  color: #c0392b;
  background-color: #fdeaea;
  border-color: #e3a9a2;
}

/* Quando o botão fica dentro da caixa de erro (padrão do print) */
.erro-interpretado .btn-copiar {
  margin-top: 8px;
}

.mensagem-bruta {
  max-height: 160px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
}
</style>
